import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import qs from 'qs';

// utils
import callApi from '../../utils/callApi';

// constants
import { BLOGS_LIST, BLOGS_LIST_BY_TAG } from '../../constants/apiUrls/apiUrls';

// components
import BlogSearchBar from '../../components/blogComponents/BlogSearchBar';
import Articles from '../../components/blogComponents/Articles';
import Pagination from '../../components/blogComponents/Pagination';

import './News.css';

// constants that i dont know where to move...yet
const title = 'News';

export const NewsPage = ({ match, location }) => {

  const [state, setState] = useState({
    currentCategoryId: undefined,
    currentPageNumber: 1,
    totalNumberOfEntries: null,
    entriesPerPage: 8,
    articles: [],
  });

  useEffect(() => {
    document.title = 'News | Naked News';
    const { id, tag } = match.params;
    let pageNumber = 1;

    if (location.search.includes('page=')) {
      const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true });
      if (searchParams.page) {
        pageNumber = parseInt(searchParams.page);
      }
    }

    let url = BLOGS_LIST;
    if (id) {
      url += `&categoryId=${id}`;
    } else if (tag) {
      url = BLOGS_LIST_BY_TAG.
        replace('{tag}', encodeURIComponent(tag));
    }

    fetchArticleList(url, id, pageNumber);

  }, [match.params, location.search]);

  const fetchArticleList = (url, categoryId, pageNumber) => {
    url = url.replace('{page}', pageNumber - 1).
      replace('{size}', state.entriesPerPage
      );

    callApi(url, 'get', {}).then((res) => {
      setState((prevState) => {
        return {
          ...prevState,
          articles: res.data.blogs,
          totalNumberOfEntries: res.data.count,
          currentCategoryId: categoryId,
          currentPageNumber: pageNumber,
        };
      });
    });
  };

  const minNrOfEntriesPerPage = () => state.currentPageNumber === 1 ? state.currentPageNumber : state.entriesPerPage * (state.currentPageNumber - 1) + 1;

  const maxNrOfEntriesPerPage = () => state.entriesPerPage * state.currentPageNumber <= state.totalNumberOfEntries ? state.entriesPerPage * state.currentPageNumber : state.totalNumberOfEntries;

  return (
    <div className="content soft-white">
      <div className="container">
        <div className="list-page" id="blog_posts">
          <h1>{title}</h1>
          <BlogSearchBar selectedCategoryId={state.currentCategoryId} />
          <Articles articles={state.articles} />
          {state.totalNumberOfEntries > state.entriesPerPage ? (
            <React.Fragment>
              <Pagination
                key={state.totalNumberOfEntries}
                activePageNumber={state.currentPageNumber * 1}
                entriesPerPage={state.entriesPerPage}
                totalNumber={state.totalNumberOfEntries}
              />
              <div className="pagnation-controls text-center">
                <div>
                  Displaying posts{' '}
                  <b>
                    {minNrOfEntriesPerPage()} -{' '}
                    {maxNrOfEntriesPerPage()}
                  </b>{' '}
                  of <b>{state.totalNumberOfEntries}</b> in total
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="pagnation-controls text-center">
              <div>
                Displaying <b>all {state.totalNumberOfEntries}</b>{' '}
                posts
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default NewsPage;
